export const replaceUrl = (originalUrl) => {
  // 目标域名
  let newDomain = "http://testadjapi.baishulai.com";

  // 执行替换
  let newUrl = originalUrl.replace(/http:\/\/api\.aidajuan\.com/, newDomain);

  // 输出结果
  return newUrl;
};

/**
 * 复制文本到剪贴板（兼容新旧浏览器）
 * @param {string} text - 需要复制的文本
 * @returns {Promise} - 返回 Promise 对象，resolve 为成功，reject 为失败
 */
export const copyText = (text) => {
  return new Promise((resolve, reject) => {
    // 1. 优先尝试使用现代 Clipboard API
    if (navigator.clipboard && window.isSecureContext) {
      // 注意：必须在 HTTPS 环境或 localhost 下才能使用
      navigator.clipboard
        .writeText(text)
        .then(() => {
          resolve("复制成功");
        })
        .catch((err) => {
          console.error("Clipboard API 失败:", err);
          reject("复制失败：" + err);
        });
    } else {
      // 2. 降级方案：使用 execCommand (兼容旧浏览器如 IE/旧版 Chrome)
      try {
        // 创建临时的 textarea 元素
        const textarea = document.createElement("textarea");
        textarea.value = text;

        // 样式设置：移出屏幕外，避免影响页面布局
        textarea.style.position = "fixed";
        textarea.style.left = "-9999px";
        textarea.style.top = "-9999px";

        document.body.appendChild(textarea);

        // 选中内容
        textarea.select();

        // 执行复制命令
        const successful = document.execCommand("copy");

        // 移除临时元素
        document.body.removeChild(textarea);

        if (successful) {
          resolve("复制成功");
        } else {
          reject("复制失败：execCommand 执行失败");
        }
      } catch (err) {
        reject("复制失败：" + err);
      }
    }
  });
};

/**
 * 下载图片（支持跨域）
 * @param {string} url - 图片地址
 * @param {string} fileName - 下载后的文件名（包含后缀，如 'avatar.jpg'）
 */
export const downloadImage = (url, fileName) => {
  // 使用 fetch 获取图片数据
  fetch(url)
    .then((response) => response.blob()) // 将响应数据转换为 blob 对象
    .then((blob) => {
      // 创建一个隐藏的 <a> 标签
      const link = document.createElement("a");
      // 生成一个指向 blob 对象的临时 URL
      link.href = URL.createObjectURL(blob);
      link.download = fileName; // 设置下载文件名

      // 模拟点击
      document.body.appendChild(link);
      link.click();

      // 清理资源
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    })
    .catch((error) => {
      console.error("下载失败:", error);
      alert("图片下载失败，请检查网络或跨域设置");
    });
};

export const generateYearList = () => {
  const currentYear = new Date().getFullYear(); // 获取当前年份（2026）
  const yearList = [];

  // 循环100次，从当前年份向前生成
  for (let i = 0; i < 100; i++) {
    const year = currentYear - i;
    yearList.push({
      id: year + "",
      year: year + "",
    });
  }

  // 数组倒序（最大的年份在最下面，最小的在上面）
  return yearList.reverse();
};

/**
 * 计算对象属性的填充百分比
 * @param {Object} obj - 需要计算的对象
 * @returns {number} 百分比数值（例如 50 表示 50%）
 */
export const calculateFillPercentage = (obj) => {
  // 1. 获取对象所有的键
  const keys = Object.keys(obj);

  // 2. 过滤掉 'id' 字段，剩下的就是需要计算的 20 个属性
  const targetKeys = keys.filter((key) => key !== "id");
  const total = targetKeys.length; // 总数应该是 20

  if (total === 0) return 0;

  // 3. 统计不为空的属性数量
  let filledCount = 0;

  targetKeys.forEach((key) => {
    const value = obj[key];

    // 判断是否为空的逻辑：
    // 1. 值为 null 或 undefined
    // 2. 值为空字符串 ''
    // 3. 值为数组且长度为 0
    const isNull = value === null || value === undefined;
    const isEmptyString = typeof value === "string" && value === "";
    const isEmptyArray = Array.isArray(value) && value.length === 0;

    // 如果以上都不是，说明是有值的（包括 false、0 等）
    if (!isNull && !isEmptyString && !isEmptyArray) {
      filledCount++;
    }
  });

  // 4. 计算百分比
  const percentage = (filledCount / total) * 100;

  // 如果需要保留小数或取整，可以在这里处理，比如 Math.round(percentage)
  return percentage;
};

export const generateUUID = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};
